import * as MUI from "@mui/material";
import { Link } from "react-router-dom";

type InputBikeProps = {
  situacao: string;
  chassi: string;
  marca: string;
  to: string;
};

export const ResultadoConsultaBike: React.FC<InputBikeProps> = ({
  situacao,
  chassi,
  marca,
  to,
}) => {
  return (
    <MUI.Paper
      component={Link}
      elevation={5}
      to={to}
      sx={{
        display: "flex",
        mb: 2,
      }}
    >
      <MUI.CardActionArea>
        <MUI.Stack
          display="flex"
          width="100%"
          flexDirection={["column", "row"]}
          p={0.5}
          gap={[0, 2]}
        >
          <MUI.Stack>
            <MUI.Divider
              orientation="vertical"
              sx={{
                borderWidth: 3.2,
                backgroundColor: "purple",
              }}
            />
          </MUI.Stack>
          <MUI.Stack flex={1}>
            <MUI.Typography variant="body2" fontWeight="bold">
              Situação:
            </MUI.Typography>
            <MUI.Typography variant="caption">{situacao}</MUI.Typography>
          </MUI.Stack>

          <MUI.Stack flex={1}>
            <MUI.Typography variant="body2" fontWeight="bold">
              Chassi:
            </MUI.Typography>
            <MUI.Typography variant="caption">{chassi}</MUI.Typography>
          </MUI.Stack>

          <MUI.Stack flex={1}>
            <MUI.Typography variant="body2" fontWeight="bold">
              Marca:
            </MUI.Typography>
            <MUI.Typography variant="caption">{marca}</MUI.Typography>
          </MUI.Stack>
        </MUI.Stack>
      </MUI.CardActionArea>
    </MUI.Paper>
  );
};
